export function delay(timeout: number): Promise<void> {
    return new Promise(resolve => {
        setTimeout(resolve, timeout);
    });
}

export function nextTick(): Promise<void> {
    return new Promise(resolve => {
        setTimeout(resolve, 0);
    });
}

export const waitUntil = async (predicate: () => boolean) => {
    while (!predicate()) {
        await nextTick();
    }
};
